export const koreanBookNames = {
  // Old Testament
  'Genesis': '창세기',
  'Exodus': '출애굽기',
  'Leviticus': '레위기',
  'Numbers': '민수기',
  'Deuteronomy': '신명기',
  'Joshua': '여호수아',
  'Judges': '사사기',
  'Ruth': '룻기',
  '1 Samuel': '사무엘상',
  '2 Samuel': '사무엘하',
  '1 Kings': '열왕기상',
  '2 Kings': '열왕기하',
  '1 Chronicles': '역대상',
  '2 Chronicles': '역대하',
  'Ezra': '에스라',
  'Nehemiah': '느헤미야',
  'Esther': '에스더',
  'Job': '욥기',
  'Psalms': '시편',
  'Proverbs': '잠언',
  'Ecclesiastes': '전도서',
  'Song of Solomon': '아가',
  'Isaiah': '이사야',
  'Jeremiah': '예레미야',
  'Lamentations': '예레미야애가',
  'Ezekiel': '에스겔',
  'Daniel': '다니엘',
  'Hosea': '호세아',
  'Joel': '요엘',
  'Amos': '아모스',
  'Obadiah': '오바댜',
  'Jonah': '요나',
  'Micah': '미가',
  'Nahum': '나훔',
  'Habakkuk': '하박국',
  'Zephaniah': '스바냐',
  'Haggai': '학개',
  'Zechariah': '스가랴',
  'Malachi': '말라기',

  // New Testament
  'Matthew': '마태복음',
  'Mark': '마가복음',
  'Luke': '누가복음',
  'John': '요한복음',
  'Acts': '사도행전',
  'Romans': '로마서',
  '1 Corinthians': '고린도전서',
  '2 Corinthians': '고린도후서',
  'Galatians': '갈라디아서',
  'Ephesians': '에베소서',
  'Philippians': '빌립보서',
  'Colossians': '골로새서',
  '1 Thessalonians': '데살로니가전서',
  '2 Thessalonians': '데살로니가후서',
  '1 Timothy': '디모데전서',
  '2 Timothy': '디모데후서',
  'Titus': '디도서',
  'Philemon': '빌레몬서',
  'Hebrews': '히브리서',
  'James': '야고보서',
  '1 Peter': '베드로전서',
  '2 Peter': '베드로후서',
  '1 John': '요한일서',
  '2 John': '요한이서',
  '3 John': '요한삼서',
  'Jude': '유다서',
  'Revelation': '요한계시록',

  // Korean to English (for reverse lookup)
  '창세기': 'Genesis',
  '출애굽기': 'Exodus',
  '레위기': 'Leviticus',
  '민수기': 'Numbers',
  '신명기': 'Deuteronomy',
  '여호수아': 'Joshua',
  '사사기': 'Judges',
  '룻기': 'Ruth',
  '사무엘상': '1 Samuel',
  '사무엘하': '2 Samuel',
  '열왕기상': '1 Kings',
  '열왕기하': '2 Kings',
  '역대상': '1 Chronicles',
  '역대하': '2 Chronicles',
  '에스라': 'Ezra',
  '느헤미야': 'Nehemiah',
  '에스더': 'Esther',
  '욥기': 'Job',
  '시편': 'Psalms',
  '잠언': 'Proverbs',
  '전도서': 'Ecclesiastes',
  '아가': 'Song of Solomon',
  '이사야': 'Isaiah',
  '예레미야': 'Jeremiah',
  '예레미야애가': 'Lamentations',
  '에스겔': 'Ezekiel',
  '다니엘': 'Daniel',
  '호세아': 'Hosea',
  '요엘': 'Joel',
  '아모스': 'Amos',
  '오바댜': 'Obadiah',
  '요나': 'Jonah',
  '미가': 'Micah',
  '나훔': 'Nahum',
  '하박국': 'Habakkuk',
  '스바냐': 'Zephaniah',
  '학개': 'Haggai',
  '스가랴': 'Zechariah',
  '말라기': 'Malachi',

  // New Testament (Korean to English)
  '마태복음': 'Matthew',
  '마가복음': 'Mark',
  '누가복음': 'Luke',
  '요한복음': 'John',
  '사도행전': 'Acts',
  '로마서': 'Romans',
  '고린도전서': '1 Corinthians',
  '고린도후서': '2 Corinthians',
  '갈라디아서': 'Galatians',
  '에베소서': 'Ephesians',
  '빌립보서': 'Philippians',
  '골로새서': 'Colossians',
  '데살로니가전서': '1 Thessalonians',
  '데살로니가후서': '2 Thessalonians',
  '디모데전서': '1 Timothy',
  '디모데후서': '2 Timothy',
  '디도서': 'Titus',
  '빌레몬서': 'Philemon',
  '히브리서': 'Hebrews',
  '야고보서': 'James',
  '베드로전서': '1 Peter',
  '베드로후서': '2 Peter',
  '요한일서': '1 John',
  '요한이서': '2 John',
  '요한삼서': '3 John',
  '유다서': 'Jude',
  '요한계시록': 'Revelation',
};
